import { themeHelpers } from '@gotamedia/fluffy';
import styled, { css } from 'styled-components';
import BannerComponent from '~/components/Banner';
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-n5gjmg-0"
})(["max-width:1320px;width:90%;margin:auto;display:flex;flex-direction:column;padding:80px 0;", ""], themeHelpers.isSmallDevice(css(["width:95%;padding:16px 0;"])));
const Content = styled.div.withConfig({
  displayName: "style__Content",
  componentId: "sc-n5gjmg-1"
})(["display:flex;"]);
const InnerWrapper = styled.div.withConfig({
  displayName: "style__InnerWrapper",
  componentId: "sc-n5gjmg-2"
})(["width:546px;min-width:546px;margin-right:80px;", " ", ""], themeHelpers.isMediumDevice(css(["width:480px;min-width:480px;margin-right:80px;"])), themeHelpers.isSmallDevice(css(["width:224px;min-width:224px;margin-right:8px;"])));
const Headline = styled.h1.withConfig({
  displayName: "style__Headline",
  componentId: "sc-n5gjmg-3"
})(["font-style:normal;font-weight:700;font-size:48px;color:#000000;margin:0 0 16px 0;", ""], themeHelpers.isSmallDevice(css(["font-size:24px;"])));
const Description = styled.p.withConfig({
  displayName: "style__Description",
  componentId: "sc-n5gjmg-4"
})(["font-style:normal;font-weight:400;font-size:20px;color:#000000;line-height:24px;", ""], themeHelpers.isSmallDevice(css(["font-size:16px;"])));
const Banner = styled(BannerComponent).withConfig({
  displayName: "style__Banner",
  componentId: "sc-n5gjmg-5"
})(["margin:auto auto auto 0;", ""], themeHelpers.isNotLargeDevice(css(["margin:auto 0 auto auto;"])));
export { Wrapper, Content, InnerWrapper, Headline, Description, Banner };